import { FieldProps } from 'formik';

import { IFilterListProps, TObjectFilterValue } from 'common/types';

import { FilterList } from './FilterList';

interface IProps
    extends FieldProps, Omit<IFilterListProps, 'value' | 'onChange'> {
    label?: React.ReactNode;
    onChange?: (name: string, value: TObjectFilterValue[]) => void;
}

/**
 * Formik adapter that lets `FilterList` be used as a field in the drawer
 * filter form (via `component: FilterListField` on a filter field).
 */
export const FilterListField = ({
    label: _label,
    onChange,
    field,
    form,
    meta: _meta,
    items,
    ...listProps
}: IProps) => {
    const selectedValues: string[] = Array.isArray(field.value)
        ? field.value.map((item: TObjectFilterValue) => item.id)
        : [];

    const handleChange = (newValue: string[]) => {
        const value = newValue.map((val) => ({
            id: val,
            name: items.find((item) => item.value === val)?.label ?? val,
        }));

        onChange?.(field.name, value);
        form.setFieldValue(field.name, value);
    };

    return (
        <FilterList
            {...listProps}
            items={items}
            value={selectedValues}
            onChange={handleChange}
        />
    );
};
